
import { Component, Vue } from 'vue-property-decorator'
//import Utils from '@/lib/utils.ts'

import { mapGetters } from 'vuex'

@Component({
  components: {},
  computed: {
    ...mapGetters({
      getDarkMode: 'getDarkMode',
      getSnackBarOpen: 'getSnackBarOpen',
      getSnackBarText: 'getSnackBarText',
      getSnackBarColor: 'getSnackBarColor',
    }),
  },
})
export default class NotificationSnackBar extends Vue {
  private timeout: number = 4000

  async closeSnackbar() {
    await this.$store.dispatch('setSnackBarOpen', false)
  }
}
